// The parts of the cash flow statement: money in, and money out. Kept apart
// from the routing so the request schemas can name them without loading it.

export const IN_PARTS = [
  "salary",
  "bonus",
  "benefits",
  "planMatch",
  "otherIncome",
  "interest",
  "dividends",
  "realised",
  "unrealised",
  "pensionGrowth",
  "otherChanges",
] as const;

export const OUT_PARTS = [
  "deductions",
  "taxes",
  "expenses",
  "pillarContributions",
  "intoInvestments",
] as const;

export type InPart = (typeof IN_PARTS)[number];
export type OutPart = (typeof OUT_PARTS)[number];
export type Part = InPart | OutPart;

const IN_SET: ReadonlySet<string> = new Set(IN_PARTS);
export const isInPart = (part: Part): part is InPart => IN_SET.has(part);
